import { DGOJ } from './jurisdictions/DGOJ';
import { MGA_GRA } from './jurisdictions/MGA_GRA';
import { PNP_MGA_GRA } from './jurisdictions/PNP_MGA_GRA';
import { UKGC } from './jurisdictions/UKGC';
import { TDynamicStoreField, useRegistrationStore } from '../../store/store';
import { currentCountryMarketInfo, FLOW_NAMES } from '../../utils/countries';

// Mapping of the jurisdictions to country codes
const objectType: Record<string, new (data: TDynamicStoreField | null) => MGA_GRA | UKGC | DGOJ | PNP_MGA_GRA> = {
  ie:      MGA_GRA,
  'en-gb': UKGC,
  es:      DGOJ,
  gi:      MGA_GRA,
  'en-ca': MGA_GRA,
  fi:      MGA_GRA,
  'en-nz': MGA_GRA,
};

const pnpObjectType: Record<string, new (data: TDynamicStoreField | null) => PNP_MGA_GRA> = {
  fi: PNP_MGA_GRA,
};

// Factory function to create instances
export const getRequestBody = (formData: TDynamicStoreField): MGA_GRA | UKGC | DGOJ | PNP_MGA_GRA => {
  const { currentMarket } = useRegistrationStore.getState();
  const marketInfo = currentCountryMarketInfo(currentMarket);
  const isPnp = marketInfo?.flowName === FLOW_NAMES.MGA_GRA_PNP;

  const ClassToInstantiate = isPnp
    ? pnpObjectType[currentMarket]
    : objectType[currentMarket];

  if (!ClassToInstantiate) {
    throw new Error(`Unknown type of the market: ${currentMarket}`);
  }

  return new ClassToInstantiate(formData).data;
};
